$(document).on('click', '.product__link-open-tab', function (e) {
    e.preventDefault();
    let activeHref = $(this).attr('href');
    let activeHandle = activeHref.replace('#', '');

    openCurrentTabpanel(activeHandle);
    scrollToAnchor(activeHref, 300);
});

function scrollToAnchor(hash, speed) {
    let headerHeight = $('header.header').height();
    if ($(window).width() > 600) {
        headerHeight = headerHeight + 50;
    }
    $('html, body').animate({scrollTop: $(`${hash}`).offset().top - headerHeight }, 300);
}

function openCurrentTabpanel(element) {
    const tabLink = $(`.tabs__link[aria-controls=${element}]`);
    if (tabLink.length > 0) {
        tabLink[0].click();
    }
}